<div class="{{styles.productType}}"><oy-radio-checkbox></oy-radio-checkbox></div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYFilter/components/OYProductType/index.art